const aiUnavailable =
  "AI features require a server backend. Configure TanStack Start server functions or an API route to enable this feature.";

export async function generateAdminInsights(): Promise<{ text: string }> {
  return { text: aiUnavailable };
}

export async function generateThankYou(_args: {
  data: { donationId: string; language?: string; tone?: string };
}): Promise<{ text: string }> {
  return { text: aiUnavailable };
}

export async function generateResidentBio(_args: {
  data: { residentId: string; audience?: string; words?: number };
}): Promise<{ text: string }> {
  return { text: aiUnavailable };
}

export async function summariseFeedback(): Promise<{ text: string; count: number }> {
  return { text: aiUnavailable, count: 0 };
}

export async function draftInquiryReply(_args: {
  data: { inquiryId: string; tone?: string };
}): Promise<{ text: string }> {
  return { text: aiUnavailable };
}

export async function generatePostCopy(_args: {
  data: {
    title: string;
    category?: string;
    notes?: string;
    words?: number;
  };
}): Promise<{ text: string }> {
  return { text: aiUnavailable };
}

export async function draftDonorReactivation(_args: {
  data: { donorId: string; channel?: string };
}): Promise<{ text: string }> {
  return { text: aiUnavailable };
}
